import { render, staticRenderFns } from "./NoAssetsLabel.vue?vue&type=template&id=39ecf83a&scoped=true&functional=true&"
import script from "./NoAssetsLabel.vue?vue&type=script&lang=ts&"
export * from "./NoAssetsLabel.vue?vue&type=script&lang=ts&"
import style0 from "./NoAssetsLabel.vue?vue&type=style&index=0&id=39ecf83a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "39ecf83a",
  null
  
)

export default component.exports